module.exports = __webpack_public_path__ + "img/successRegister.700bd717.700bd717.svg";